
import Splash from "../Pages/Splash";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import OrderDetails from "../Pages/Orders/OrderDetails";
import ROrders from "../Pages/Home/ROrders";
import ROrderDetails from "../Pages/Orders/ROrderDetails";
import SendingOrders from "../Pages/Home/SendingOrders";
import BOrderDetails from "../Pages/Orders/BOrderDetails";
import BOrders from "../Pages/Orders/BOrders";
import BOrdersQC from "../Pages/Orders/BOrdersQC";


const appRoutes = [
    {
        pageId : 1,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 4,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 5,
        path: "/orders",
        component: <SendingOrders />,
    },
    {
        pageId : 8,
        path: "/orders/:id",
        component: <OrderDetails />,
    },
    {
        pageId : 9,
        path: "/returned-orders/:id",
        component: <ROrderDetails />,
    },

    {
        pageId : 10,
        path: "/returned-orders",
        component: <ROrders />,
    },
    {
        pageId : 11,
        path: "/sb-orders/:id",
        component: <BOrderDetails />,
    },
    {
        pageId: 12,
        path: "/sb-orders",
        component: <BOrders/>
    },
    {
        pageId: 13,
        path: "/sb-orders-qc",
        component: <BOrdersQC/>
    }
];
export default appRoutes;